import { FormData } from "src/components/MyGarage/VehicleHeader/ExploreMore/ReserveVehicle/ReserveVehicleForm";
import { postTo } from "src/store/dataService/routes/shared/osfetch";

export interface ReserveVehicleRequestPayload {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    comment?: string;
}

export function mapFormDataToRequestPayload(formData: FormData): ReserveVehicleRequestPayload {
    const payload = {
        first_name: formData.firstName,
        last_name: formData.lastName,
    } as ReserveVehicleRequestPayload;

    if (formData.email) {
        payload.email = formData.email;
    }
    if (formData.phone) {
        payload.phone = formData.phone.replace(/[^0-9]/g, "");
    }
    if (formData.comments) {
        payload.comment = formData.comments;
    }
    return payload;
}

export const reserveVehicle = (dealId: string | null, vin: string, formData: FormData) => {
    return postTo(`/deals/${dealId}/vehicles/${vin}/reserve`, mapFormDataToRequestPayload(formData)).then(
        (response: Response) => {
            if (!response.ok) {
                throw new Error("Unable to reserve vehicle");
            }
            return true;
        }
    );
};
